<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0040_certificate_information_pegging</div>
        <app-header>esma</app-header>
        <div :class="'container ' +pageContainerSize">
          <title-and-search title="紐付機器一覧"></title-and-search>
        <div> 紐付けした機器を解除する場合：機器を選択して[紐付解除]をクリック</div>
　　　　 <div>紐付けする機器を追加する場合：[追加]をクリックして機器を選択</div>
         <br>
          <search-control 
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <ag-grid-vue style="width: 100%; height: 230px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
             件数<input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <button :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" @click="confirmPositiveProcess">戻る</button>
            <button :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" >紐付解除</button>
            <router-link
                  to="/certificate_information_pegging_choice"
                  type="button"
                  class="btn btn-primary btn-xs"
                  style="float: right;margin-left: 10px;"
            >　追加　</router-link>
            <button :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" @click="onConfirmExecuteProcess" >申請</button>
            <br>
            <br>
          <!-- <button :disabled="selected_row == -1" class="btn btn-danger btn-xs" style="float: right;margin-left: 10px;" @click="onDelete">抹消</button>
          <button :disabled="selected_row == -1" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;"  @click="onEdit">編集</button> -->
          </div>
        </div>
        <confirmation-modal tag="confirmPositiveProcess" @done="onConfirmPositiveProcess" />
        <certificate-information-connection-application-modal tag="showBulkImportConfimationModal" />
        <device-embedded-information-bach-edit-modal tag="showDeviceEmbeddedInformationBachEditModal" @save="onDeviceEmbeddedInformationBachEditModalSave" @cloase="onDeviceEmbeddedInformationBachEditModalClose" />
    </div>
</template>

<script>
import Vue from 'vue';
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_certificate_information';
import { utils } from '@/libs/utils';


import deviceEmbeddedInformationBachEditModal from '@/components/modals/device-embedded-information-bach-edit-modal';
import bulkImportConfirmationModal from "@/components/modals/certificate-information-connection-application-modal";
import _debug from 'debug';
var mdebug = _debug('esma:certificate_information');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    "certificate-information-connection-application-modal" :bulkImportConfirmationModal,
    'device-embedded-information-bach-edit-modal' : deviceEmbeddedInformationBachEditModal
  },
  data() {
    return {
      api_name:"certificate_information",
      page_acl: acl.generic,
      detail_page:"page_0040_certificate_information_detail"
    };
  },
  computed: {
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.certificate_management_number, {}),
        utils.extend(fields.license_jurisdiction_team, {}),
        utils.extend(fields.jurisdiction_classification, {}),
        utils.extend(fields.license_jurisdiction_system, {}),
        utils.extend(fields.licensed_department, {}),
        utils.extend(fields.maker, {}),
        utils.extend(fields.license_name, {}),
        utils.extend(fields.effective_number, {}),
        utils.extend(fields.remaining_number, {}),
      ];
    }
  },
  methods: {
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    onExecuteProcess(){
      if(this.tab_name_mode == false){
        return;
      }
       if(this.tab_name_mode == false){
        return;
      }

      this.$ajax.post('/' + this.tab_name_mode + '/process/' , {}, (err, result) => {
        if(err){
          this.$notify({
            title: 'データの処理に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        }else{
          this.confirmPositiveProcess();
        }

      })
    },
    confirmPositiveProcess(){
      bus.$emit("confirmPositiveProcess",{
        title: "",
        message: "紐付内容に変更があります。申請せずに戻りますか？",
        yes_label: "",
        no_label: "戻る",
        yes_color:"",
        no_color:"default",
        model_height:"50"
      });
    },
    onConfirmPositiveProcess(){
        if(this.tab_name_mode == "temp_device_embedded_information"){
           this.$router.push({
              name: "page_0010_device_embedded_information"
            });
        }else if(this.tab_name_mode == "temp_certificate_information"){
           this.$router.push({
              name: "page_0040_certificate_information"
            });
        }
    },
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true})
    },
    onRowSelected(ev){
      this.selected_row = ev.node.data.seq_id;
    },
    onConfirmExecuteProcess(){
      bus.$emit("showBulkImportConfimationModal",{

      });
    },
  },
  mounted() {
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0040_certificate_information_pegging.vue?3f40f62c